export default __webpack_public_path__ + "static/media/travel.cb12cdb5.png";